(() => {
  const ROOT = 'product-info';

  function looksLikeVelocity(el) {
    if (!(el instanceof HTMLElement)) return false;
    const text = (el.innerText || el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (!text) return false;
    const hasVelocity = text.includes('velocity');
    const hasEmi = text.includes('buy on emi') || text.includes('0% emi') || text.includes('/ month');
    return hasVelocity && hasEmi;
  }

  function hideVelocity() {
    const root = document.querySelector(ROOT) || document.body;
    if (!root) return;

    const all = Array.from(root.querySelectorAll('div, section, aside, iframe, shopify-payment-terms, [class], [id]'));

    for (const el of all) {
      if (el instanceof HTMLIFrameElement) {
        const src = (el.getAttribute('src') || '').toLowerCase();
        const title = (el.getAttribute('title') || '').toLowerCase();
        if (src.includes('velocity') || title.includes('velocity') || title.includes('emi')) {
          const wrap = el.parentElement;
          (wrap || el).style.setProperty('display', 'none', 'important');
        }
        continue;
      }

      if (!looksLikeVelocity(el)) continue;

      let target = el;
      for (let i = 0; i < 5 && target.parentElement && target.parentElement !== root; i++) {
        const parent = target.parentElement;
        const parentText = (parent.innerText || parent.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        const rect = parent.getBoundingClientRect();
        if (parentText.includes('velocity') && (parentText.includes('buy on emi') || parentText.includes('0% emi')) && rect.height <= 220) {
          target = parent;
        } else {
          break;
        }
      }

      target.style.setProperty('display', 'none', 'important');
      target.setAttribute('data-kenzio-hidden-velocity', 'true');
    }
  }

  const observer = new MutationObserver(() => hideVelocity());
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideVelocity, { once: true });
  } else {
    hideVelocity();
  }

  [100, 300, 700, 1200, 2000, 3500, 6000].forEach((ms) => setTimeout(hideVelocity, ms));
})();